import { BidHistoryActionEnum, IClearSubmissionHistoryAction, IFetchedSubmissionHistorySuccessfullyAction, IFetchSubmissionHistoryAction } from '.';
import {
  ISubmissionHistoryItems,
} from '../../services';



export const FetchSubmissionHistory = (documentId?: string) => {
  return {
    type: BidHistoryActionEnum.FetchSubmissionHistory,
    state: { submissionHistory: { loading: true, documentId} },
  } as IFetchSubmissionHistoryAction;
};

  export const FetchedSubmissionHistorySuccessfully = (submissionHistoryItems: ISubmissionHistoryItems[]) => {
  return {
    type: BidHistoryActionEnum.FetchedSubmissionHistorySuccessfully,
    state: { submissionHistory: { loading: false, submissionHistoryItems} },
  } as IFetchedSubmissionHistorySuccessfullyAction;
};


export const ClearSubmissionHistory = () => {
  return {
    type: BidHistoryActionEnum.ClearSubmissionHistory,
  } as IClearSubmissionHistoryAction;
};
